import React from 'react';
import { ChatMessageFrame } from './ChatMessageFrame';
import type { CommonMessageProps } from './ChatMessageFrame';
import { withScaledEmoji } from './scaledEmoji';

/**
 * Props for a {@link ChatTextMessage} component.
 */
export type ChatMessageProps = CommonMessageProps & {
  /**
   * Text of the message.
   */
  text: string;
  /**
   * Renders `text` as a muted placeholder for a message that could not be
   * decrypted.
   */
  isUndecryptable?: boolean;
};

export default function ChatTextMessage({
  person,
  text,
  isUndecryptable = false,
  emojiData = { categories: {}, emojis: {} },
  ...frameProps
}: Readonly<ChatMessageProps>): React.JSX.Element {
  return (
    <ChatMessageFrame
      prefix="text"
      person={person}
      emojiData={emojiData}
      {...frameProps}
    >
      <div className={`text-message-body ${person.isSender ? 'sender' : ''}`}>
        {isUndecryptable ? (
          <p
            className="chat-message-text undecryptable"
            data-testid="chat-message-undecryptable"
          >
            {text}
          </p>
        ) : (
          <p className="chat-message-text">
            {withScaledEmoji(text, emojiData)}
          </p>
        )}
      </div>
    </ChatMessageFrame>
  );
}
